import { ContainerModule } from '@evertel/di'
import { RoomsSearchController, RoomController, CloneRoomController, RoomSettingsController,
    RoomDirectorySearchController, SharedRoomController, RoomJoinRequestsController,
    RoomInvitesController, ICRoomSettingsController, JoinRoomController, CreateRoomController,
    RoomForwardedMessageController, RoomConnectorsController } from './controllers'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(RoomsSearchController).toSelf()
        m.bind(RoomController).toSelf()
        m.bind(CloneRoomController).toSelf()
        m.bind(RoomSettingsController).toSelf()
        m.bind(RoomDirectorySearchController).toSelf()
        m.bind(SharedRoomController).toSelf()
        m.bind(RoomJoinRequestsController).toSelf()
        m.bind(RoomInvitesController).toSelf()
        m.bind(ICRoomSettingsController).toSelf()
        m.bind(JoinRoomController).toSelf()
        m.bind(CreateRoomController).toSelf()
        m.bind(RoomForwardedMessageController).toSelf()
        m.bind(RoomConnectorsController).toSelf()
    })
]

export { DI_MODULES }
